import { render } from "./DepositRecords.vue?vue&type=template&id=ae3d3ca2&scoped=true"
import script from "./DepositRecords.vue?vue&type=script&lang=js"
export * from "./DepositRecords.vue?vue&type=script&lang=js"

import "./DepositRecords.vue?vue&type=style&index=0&id=ae3d3ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3d3ca2"]])

export default __exports__